import React from 'react';
import { FormattedMessage } from 'react-intl';

import { messages } from '../messages';

export const hotkeysAndBarcode = {
  id: 'hotkeys-and-barcode',

  getDocumentRequestNotificationProps: (docCount, selectedPrinterName) => ({
    title: <FormattedMessage {...messages.printingHotkeysAndBarcodeTitle} values={{ docCount }} />,
    content: <FormattedMessage {...messages.sentToPrinter} values={{ selectedPrinterName }} />,
  }),
};
